const requestAnimationFrame = globalThis.requestAnimationFrame || setTimeout
const cancelAnimationFrame = globalThis.cancelAnimationFrame || clearTimeout

// #region Schedule Class ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export class Schedule {
  static init: ScheduleInit = requestAnimationFrame
  static stop: ScheduleStop = cancelAnimationFrame

  callback!: ScheduleCallback
  id!: number
  delay!: number

  constructor(callback: ScheduleCallback, delay = 0) {
    this.callback = callback
    this.delay = delay
    this.id = -1
  }

  start() {
    this.queue()

    this.callback(performance.now())

    return this
  }

  queue() {
    const { init, stop } = this.constructor as typeof Schedule

    stop(this.id)

    this.id = init(this.callback, this.delay)

    return this
  }

  clear() {
    const { stop } = this.constructor as typeof Schedule

    stop(this.id)

    return this
  }
}

// #endregion ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

// #region Frame Scheduler Class ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export class Frame extends Schedule {
  static init = requestAnimationFrame
  static stop = cancelAnimationFrame
}

// #endregion ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

// #region Interval Scheduler Class  ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export class Interval extends Schedule {
  static init = setInterval
  static stop = clearInterval
}

// #endregion ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

// #region Delay Scheduler Class ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export class Delay extends Schedule {
  static init = setTimeout
  static stop = clearTimeout
}

// #endregion ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

// #region Scheduler Typings ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

interface ScheduleInit {
  (callback: ScheduleCallback, time?: number): number
}

interface ScheduleStop {
  (id: number): void
}

interface ScheduleCallback {
  (time: number): any
}

// #endregion ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
